import type { FC } from 'react';
import { memo } from 'react';

import type { GenericPostDetailProps } from '@/features/posts/components/detail/GenericPostDetailView';
import { PostCard } from '@/features/posts/components/feed/PostCard';
import { PostCardActions } from '@/features/posts/components/feed/PostCardActions';
import { PostCardBody } from '@/features/posts/components/feed/PostCardBody';
import { PostProvider } from '@/features/posts/components/feed/PostCardContext';
import { PostCardHeader } from '@/features/posts/components/feed/PostCardHeader';
import { PostCardImage } from '@/features/posts/components/feed/PostCardImage';
import { PostHeaderInfo } from '@/features/posts/components/feed/PostHeaderInfo';

export const GroupPostScreenFeedCard: FC<{
  post: GenericPostDetailProps;
  hidePostType?: boolean;
}> = memo(({ post, hidePostType }) => (
  <PostProvider value={post}>
    <PostCard>
      <PostCard.Content>
        <PostCardImage />
        <PostCardHeader hidePostType={hidePostType} />
        <PostCardBody />
      </PostCard.Content>
      <PostCard.Actions>
        <PostCardActions />
      </PostCard.Actions>
    </PostCard>
  </PostProvider>
));
GroupPostScreenFeedCard.displayName = 'GroupPostScreenFeedCard';

export const PostScreenFeedCard: FC<{
  post: GenericPostDetailProps;
  hidePostType?: boolean;
}> = memo(({ post, hidePostType }) => (
  <PostProvider value={post}>
    <PostCard>
      <PostCard.Content>
        <PostHeaderInfo />
        <PostCardImage />
        <PostCardHeader hidePostType={hidePostType} />
        <PostCardBody />
      </PostCard.Content>
      <PostCard.Actions>
        <PostCardActions />
      </PostCard.Actions>
    </PostCard>
  </PostProvider>
));
PostScreenFeedCard.displayName = 'PostScreenFeedCard';
